module.exports = __webpack_public_path__ + "img/Maersk_fengmian.dac02167.png";